RivalIQ.apps.AdsInsights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const config = [
        {
            name: 'page',
            sizes: {
                md: 12
            },
            page: 0
        }
    ];

    const ManageColumnsBtn = RivalIQ.views.Link.mixin({
        className: 'btn btn-default manage-columns',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        linkName: 'Edit Metrics',
        action: function () {
            const me = this;

            RivalIQ.execute('show:modal', new App.views.TableMetricChooser({
                dashboardModel: me.dashboardModel
            }));
        }
    });


    const FacebookAdsInsightsDetailsLayout = Dashboard.views.DetailsLayout.extend({

        className: 'flex-toolbar-layout details',

        showLeftToolbarActions: function () {
            const me = this;

            me.showBackLink();

            const navToolbar = new App.views.NavToolbarView({
                dashboardModel: me.dashboardModel
            });
            me.leftActions.show(navToolbar, {
                preventDestroy: true
            });
        },

        showToolbarActions: function () {
            const me = this;

            me.actions.show(new ManageColumnsBtn({
                dashboardModel: me.dashboardModel.curation
            }));
            me.showExportDropdown();
        }
    });

    const FacebookAdsInsightsLayout = Dashboard.views.CurationLayout.extend({
        config: config,

        className: 'flex-toolbar-layout',

        template: '#adsInsightsCurationLayoutTemplate',

        ui: {
            noAdImpressions: '.no-ad-impressions',
            widgets: '.dashboard-regions'
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        showToolbars: function () {
            const me = this;

            me.showLeftToolbarActions();
            me.showActions();
        },

        showActions: function () {
            const me = this;

            me.actions.show(new ManageColumnsBtn({
                dashboardModel: me.dashboardModel
            }));
            me.showExportDropdown();
        },

        showLeftToolbarActions: function () {
            const me = this;

            const navToolbar = new App.views.NavToolbarView({
                dashboardModel: me.dashboardModel
            });
            me.leftActions.show(navToolbar);
        },

        loadData: function () {
            const me = this;

            const metric = RivalIQ.metric.build(me.getProps(), {
                dimensions: ['timeAnalysisMode', 'adObjectId', 'channel'],
                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                property: 'impressions',
                breakdownName: undefined,
                childObjectType: undefined,
                limit: 1
            });
            const impressionsMetric = new RivalIQ.models.MetricDefinition(metric);

            return impressionsMetric.fetch()
                .done(function (impressions) {
                    me.objectHadNoImpressions = _.isEmpty(impressions.getValue({
                        format: false
                    }));
                });
        },

        onLoadDataError: function (error) {
            const me = this;

            App.utils.handleLoadDataError(error, me.loadingView, me.dashboardModel);
        },

        refresh: function () {
            const me = this;
            me.toggleView();
        },

        onRenderLoaded: function () {
            const me = this;

            me.showToolbars();
            me.toggleView();
        },

        toggleView: function () {
            const me = this;

            me.requestRenderedFrame(function () {
                if (me.objectHadNoImpressions) {
                    me.ui.noAdImpressions.show();
                    me.ui.widgets.hide();
                } else {
                    me.ui.noAdImpressions.hide();
                    me.ui.widgets.show();
                }
            });
        }
    });

    const ExportLayout = Dashboard.views.ExportWidgets.extend({
        getTitleView: function () {
            const me = this;
            if (me.dashboardModel.isExportingPDF()) {
                return App.views.TitlePage;
            }

            return App.views.TitleBar;
        }
    });

    curations.FacebookAdsInsightsCuration = Dashboard.models.Curation.mixin({
        mixins: {
            Switchable: Dashboard.mixins.Switchable,
            exportHD: RivalIQ.apps.Dashboard.mixins.ExportHD,
            CurationBufferedEventProxy: Dashboard.mixins.CurationBufferedEventProxy
        },

        beforeFilters: [
            curations.filters.checkFeatureAccess,
            RivalIQ.apps.Dashboard.curations.filters.privateDataFeatureAccess(RivalIQ.enums.sources.FACEBOOK_ADS, {
                template: '#widgetAdsInsightsAuthTemplate'
            }),
            curations.filters.loadFacebookAdAccounts,
            curations.filters.loadAdObject,
            RivalIQ.apps.Dashboard.curations.filters.updateShell,
            curations.filters.setPageTitle,
            curations.filters.loadAdLabelsAndCustomConversions,
            curations.filters.removeInapplicableTableMetrics,
            RivalIQ.adBlockerDetector.checkAndShowAdBlockerForCuration(RivalIQ.enums.curation.FACEBOOK_ADS_INSIGHTS, RivalIQ.str('curation_ad_blocker_nag_message', 'Facebook Ads'))
        ],

        companySets: false,

        getCurationId: function () {
            const me = this;
            return `${me.id.toLowerCase()}-${me.getProp('adAccountId')}`;
        },

        // Facebook Ad ObjectIds can overflow Number, so let's just keep them as strings (default parseParams
        // would convert them to Numbers).
        parseParams: function (params) {
            const me = this;
            return _.defaults(_.pick(params, 'adObjectId'),
                RivalIQ.apps.Dashboard.models.Curation.prototype.parseParams.call(me, params));
        },

        widgetView: FacebookAdsInsightsDetailsLayout,
        widgetsView: FacebookAdsInsightsLayout,
        exportWidgetsView: ExportLayout,

        baseMetric: {
            timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
            dimensions: ['timeAnalysisMode', 'channel', 'adObjectId']
        },

        processProps: function (props) {
            const me = this;

            me.baseMetric = RivalIQ.metric.build(props, me.baseMetric);

            return props;
        },

        getFilename: function () {
            const me = this;
            return App.utils.getExportFilename(me.getProps(), me.adObject);
        },

        exportShowFocusCompany: false,
        exportShowLandscapeName: false,
        getExportSubtitle: function () {
            const me = this;
            return _.compact([
                App.utils.breadcrumbString(me.adObject),
                App.utils.getFiltersDescription(me.getProps(), me.adLabels)
            ]);
        },

        getTitleSlide: function () {
            const me = this;

            const slideElements = {
                head: me.getPptTitle(),
                date: me.getExportTitleBarTimePeriod(),
                brand: RivalIQ.apps.Reports.models.Slide.brandImages.getLarge()
            };

            let title = App.utils.breadcrumbString(me.adObject);
            const filters = App.utils.getFiltersDescription(me.getProps(), me.adLabels);
            if (filters) {
                title += `\n${filters}`;
            }

            slideElements.focusCompanyTitle = '';
            slideElements.focusCompany = title;

            return new RivalIQ.apps.Reports.models.Slide({
                style: RivalIQ.apps.Reports.models.Slide.styleTypes.INTRO,
                elements: slideElements
            });
        },

        loadConfiguration: function () {
            const me = this;

            // the configuration id depends on the adAccountId being set; if it's not, the loadFacebookAdAccounts filter
            // will set it for us and we'll run this filter again.
            if (!me.getProp('adAccountId')) {
                return new $.Deferred().resolve(me.buildConfiguration());
            }

            return RivalIQ.data.configuration.fetch(me, me.getProps())
                .then(function (configuration) {

                    const definitions = configuration.get('definitions');
                    const objectTable = _.find(definitions, {
                        instanceId: 'ad_objects_table'
                    });
                    const exploreLevel = me.getProp('exploreLevel');

                    if (objectTable && exploreLevel) {
                        objectTable.baseMetric.childObjectType = exploreLevel;
                    }

                    return configuration;
                });
        },

        getBackPath: function (widgetProps) {
            const me = this;
            const props = _.pick(widgetProps, App.utils.validCurationOptions);
            return me.getBasePath(props);
        },

        getPropsForSerialization: function (props) {
            return _.pick(props, 'tableMetrics');
        },

        getExportTitle: function () {
            return RivalIQ.strings.facebook_ads_insights_app_title;
        },

        getTitle: function () {
            const me = this;

            const currentAdAccount = _.find(me.facebookAdAccounts, {
                id: me.getProp('adAccountId')
            });
            return _.compact([RivalIQ.strings.facebook_ads_insights_app_title, _.get(currentAdAccount, 'name')]).join(' / ');
        },

        titleView: function () {
            const me = this;

            const switchable = me.getSwitchableTitleView({
                hasEditButton: true,
                titleViewEditName: 'Edit Mapped Accounts'
            });

            me.listenTo(switchable, 'title:edit', me.onTitleEdit);

            return switchable;
        },

        onTitleEdit: function () {
            const me = this;

            const view = new App.views.FacebookAdAccounts({
                template: '#facebookAdAccountsListSettingsModalTemplate'
            });

            me.listenTo(view, 'click:done', me.reload);

            RivalIQ.execute('show:modal', view);
        },

        saveLastSelectedAdAccount: function (facebookAdAccount) {
            const me = this;

            const landscapeId = me.getProp('landscapeId');
            const lastSelectedAdAccounts = RivalIQ.state.user.get('lastSelectedAdAccounts') || {};

            lastSelectedAdAccounts[landscapeId] = facebookAdAccount.id;

            RivalIQ.state.user.set({
                lastSelectedAdAccounts: lastSelectedAdAccounts
            });
        },

        getSwitchableItems: function () {
            const me = this;

            return _.map(me.facebookAdAccounts, function (facebookAdAccount) {
                return {
                    value: facebookAdAccount.id,
                    display: facebookAdAccount.name,
                    action: function () {
                        const path = me.getPath({
                            adAccountId: facebookAdAccount.id,
                            adObjectId: facebookAdAccount.id,
                            exploreLevel: RivalIQ.enums.facebookAdObjectTypes.CAMPAIGN,
                            tableMetrics: undefined
                        });

                        me.saveLastSelectedAdAccount(facebookAdAccount);
                        RivalIQ.execute('history:navigate', path, {
                            trigger: true
                        });
                    }
                };
            });
        },

        secondaryNavigationView: function () {
            const me = this;

            if (me.getProp('adAccountId') && me.getProp('adObjectId')) {
                return new App.views.SecondaryNavigation({
                    dashboardModel: me
                });
            }
        },

        getBasePath: function (overrides) {
            const me = this;

            const props = _.extend({
                adAccountId: me.getProp('adAccountId'),
                adObjectId: me.getProp('adObjectId'),
                exploreLevel: me.getProp('exploreLevel')
            }, overrides);

            return me.router.resolveCurationRoute(me.id, props);
        }

    });

});
